import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SHOWS } from '../data/shows';

export function MagicShowsGrid({ exclude, title = 'Nos spectacles de magie', intro, testid = 'magic-shows-grid' }) {
  const items = Object.entries(SHOWS).filter(([slug]) => slug !== exclude);
  return (
    <section className="py-16 lg:py-20 px-4 bg-white" data-testid={testid}>
      <div className="max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold text-ink mb-3">{title}</h2>
        {intro && <p className="text-ink-muted max-w-2xl mb-10">{intro}</p>}
        <div className={`grid sm:grid-cols-2 ${items.length > 3 ? 'lg:grid-cols-4' : 'lg:grid-cols-3'} gap-6 ${intro ? '' : 'mt-8'}`}>
          {items.map(([slug, s]) => (
            <Link key={slug} to={`/${slug}`} className="group block rounded-3xl overflow-hidden bg-pink-50/50 border border-pink-100 hover:-translate-y-1 hover:shadow-xl transition-[transform,box-shadow] duration-300" data-testid={`magic-show-card-${slug}`}>
              <div className="aspect-[2/3] bg-white overflow-hidden">
                <img src={s.poster} alt={s.posterAlt} loading="lazy" className="w-full h-full object-contain p-3 group-hover:scale-[1.03] transition-transform duration-500" />
              </div>
              <div className="p-5">
                <span className="text-xs font-bold uppercase tracking-wide text-primary">{s.badge}</span>
                <h3 className="font-heading text-lg font-bold text-ink mt-1">{s.name}</h3>
                <p className="text-sm text-ink-muted mt-1 line-clamp-2">{s.subtitle}</p>
                <span className="mt-3 inline-flex items-center gap-1 text-sm font-semibold text-primary">Découvrir <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" /></span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
